export default function (imageUrl) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageUrl;
    image.crossOrigin = "Anonymous";
    image.onerror = function () {
      reject(new Error("cross-origin image load error"));
    };
    image.onload = ({ target }) => resolve(target);
  });
}
